<p-messages severity="warn">
  <ng-template pTemplate>
    <div class="ml-2">Página não encontrada</div>
  </ng-template>
</p-messages>
<a [routerLink]="['/']"> Voltar página Inicial </a>
